import DesignTokens from '@tableau/design-tokens';
import { UsersGroupIcon } from '@tableau/icons/UsersGroupIcon';
import { ButtonType, DialogFooterButtonsWidget, DialogPositioningBehavior, DialogType, DialogWidget, ListItem,LocallyFilteringList } from '@tableau/widgets';
import React, { ReactElement, useRef, useState } from 'react';
import { classes } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { applyColor }from '~src/style/ColorService';
import { IGroupInfo } from '~src/userManagement/groups/models/IGroupInfo';

import { styles } from './AgentSectionStyles';
import { getTestId } from './AgentSectionsUtils';
import { Agent } from './AgentSectionTypes';

const getGroupContent = (group: IGroupInfo) => <div className={styles.hasIcon}>{group.isAllUsersGroup ? null : <UsersGroupIcon size={14} className={classes(styles.icon, styles.groupIcon)}/>}<div>{(group.name ?? group.groupLuid)}</div></div>;

export interface AgentGroupPermissionsDialogProps{
    agent: Agent;
    agentLabel: string;
    groups: IGroupInfo[];
    handleClose: () => void;
    chooseGroup: (groupId: string) => void;
}

function filterFunction(item: ListItem, filterText: string) {
    return item.tooltip.toLowerCase().search(filterText.toLocaleLowerCase()) > -1;
}


export const AgentGroupPermissionsDialog = ({agent: agent, agentLabel, groups, handleClose, chooseGroup}: AgentGroupPermissionsDialogProps): ReactElement => {
    const groupItems: ListItem[] = groups.map((group) => ({
        value: group.groupLuid,
        content: getGroupContent(group),
        testId: getTestId('AgentGroupPermissionsDialog_group', group.groupLuid),
        tooltip: group.name ?? group.groupLuid,
    }));
    const [selected, setSelected] = useState<string | null>(agent.groupId);
    const ref = useRef<LocallyFilteringList>(null);

    const handleSelect = (val: string) => {
        if (val === selected) {
            setSelected(null);
        } else {
            setSelected(val);
        }
    };

    return <DialogWidget
            type={DialogType.NormalWithTitleBar}
            title={Messages.settings_agents_grant_access_to()}
            testId={getTestId('AgentGroupPermissionsDialog')}
            showCloseButton={true}
            onCloseRequest={handleClose}
            dialogWidth={500}
            positioningBehavior={DialogPositioningBehavior.Centered}
            footerContent={<DialogFooterButtonsWidget buttons={[
                {
                    buttonType: ButtonType.Outline,
                    testId: getTestId('AgentGroupPermissionsDialog_button_cancel'),
                    onClick: handleClose,
                    children: Messages.cancel(),
                },
                {
                    buttonType: ButtonType.Primary,
                    testId: getTestId('AgentGroupPermissionsDialog_button_apply'),
                    onClick: () => {chooseGroup(selected); handleClose();},
                    children: Messages.apply(),
                },
            ]} />}
            handleGlassClick={handleClose}
            isModal={true}>
            <p>{Messages.settings_agents_dialog_text({agent_name: agentLabel})}</p>
            <LocallyFilteringList
                items={groupItems}
                ref={ref}
                itemFilterFn={filterFunction}
                style={{
                    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, 'rgb(178,178,178)'),
                    height: 300,
                    width: '100%'
                }}
                selectedValue={selected}
                onSelect={handleSelect}
                testId={getTestId('AgentGroupPermissionsDialog_List')}
                />
            </DialogWidget>;
};